<template>
  <section class="video-section section" id="videos">
    <!-- Header inside container -->
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="5 3 19 12 5 21 5 3"/></svg>
          IP短视频
        </div>
        <h2 class="section-title">IP短视频 <span class="gradient-text">推荐</span></h2>
        <p class="section-subtitle">多智能体IP短视频内容生产线，AI全程参与创作，批量生产高质量IP内容</p>
      </div>

      <!-- Category filters -->
      <div class="video-filters">
        <button
          v-for="cat in videoCategories"
          :key="cat"
          class="filter-btn"
          :class="{ active: activeVideoCategory === cat }"
          @click="activeVideoCategory = cat"
        >{{ cat }}</button>
      </div>
    </div>

    <!-- Full-width auto-scroll strip -->
    <div class="video-strip-outer">
      <div class="video-strip" :class="{ paused: isPaused }" @mouseenter="isPaused = true" @mouseleave="isPaused = false">
        <!-- Double the items for seamless loop -->
        <div
          v-for="(video, i) in doubledVideos"
          :key="video.id + '_' + i"
          class="video-card"
          @click="openPlayer(video)"
        >
          <!-- Portrait thumbnail -->
          <img :src="video.portraitThumb" :alt="video.title" class="card-img" loading="lazy" />

          <!-- Gradient overlay -->
          <div class="card-overlay"></div>

          <!-- Type badge (top) -->
          <div class="card-type">{{ video.type }}</div>

          <!-- Play icon (center, hover only) -->
          <div class="card-play">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
          </div>

          <!-- Bottom info over overlay -->
          <div class="card-bottom">
            <h4 class="card-title">{{ video.title }}</h4>
            <div class="card-tags">
              <span v-for="tag in video.tags.slice(0,3)" :key="tag" class="card-tag">{{ tag }}</span>
            </div>
            <div class="card-views">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              {{ video.views }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Video Modal -->
    <transition name="modal-fade">
      <div v-if="showModal" class="modal-overlay" @click.self="closePlayer">
        <div class="modal-player">
          <button class="modal-close" @click="closePlayer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <div class="modal-video">
            <div class="video-player-mock">
              <img :src="currentVideo ? currentVideo.thumb : ''" :alt="currentVideo ? currentVideo.title : ''" class="player-thumb" />
              <div class="player-overlay">
                <div class="player-play-btn" @click="togglePlay">
                  <svg v-if="!isPlaying" width="32" height="32" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                </div>
              </div>
              <div class="player-controls">
                <div class="progress-bar" @click="seek($event)">
                  <div class="progress-fill" :style="{ width: progress + '%' }"></div>
                  <div class="progress-thumb" :style="{ left: progress + '%' }"></div>
                </div>
                <div class="player-info">
                  <span v-if="currentVideo">{{ currentVideo.title }}</span>
                  <span class="time-display">{{ timeDisplay }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-info" v-if="currentVideo">
            <h3 class="modal-title">{{ currentVideo.title }}</h3>
            <p class="modal-desc">{{ currentVideo.desc }}</p>
            <div class="modal-tags">
              <span v-for="tag in currentVideo.tags" :key="tag" class="card-tag">{{ tag }}</span>
            </div>
            <div class="modal-cta">
              <router-link :to="AGENTS_ASSISTANT" class="btn-primary">用AI制作同款视频</router-link>
              <router-link :to="WORKFLOW_STORE" class="btn-outline">查看工作流</router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { AGENTS_ASSISTANT, WORKFLOW_STORE } from '@/constants/homeNav'

const makePortraitThumb = (seed) => `https://picsum.photos/seed/${seed}/270/480`

export default {
  name: 'VideoSection',
  data() {
    return {
      AGENTS_ASSISTANT,
      WORKFLOW_STORE,
      activeVideoCategory: '全部',
      showModal: false,
      currentVideo: null,
      isPlaying: false,
      progress: 0,
      playInterval: null,
      isPaused: false,
      videoCategories: ['全部', '口播', '宣传片', '信息流', '数字人', '混剪', '图视'],
      videos: [
        { id: 'v1', title: '7天瘦10斤！超有效减脂方法', desc: '健康生活方式分享，AI生成的口播减脂科普视频，真实自然风格', type: '口播', category: '口播', thumb: 'https://picsum.photos/seed/vid1/480/270', portraitThumb: makePortraitThumb('vid1p'), duration: '1:23', views: '12.3万', likes: '8.9千', tags: ['健康', '减脂', '生活'] },
        { id: 'v2', title: '2024年最值得学的3个副业技能', desc: 'AI生成职场成长类口播视频，信息密度高，适合职场人群', type: '口播', category: '口播', thumb: 'https://picsum.photos/seed/vid2/480/270', portraitThumb: makePortraitThumb('vid2p'), duration: '2:15', views: '89.6万', likes: '4.2万', tags: ['副业', '职场', '技能'] },
        { id: 'v3', title: '这个AI工具让我效率提升10倍', desc: 'AI工具推荐类视频，AI自动生成演示脚本和配音方案', type: '口播', category: '口播', thumb: 'https://picsum.photos/seed/vid3/480/270', portraitThumb: makePortraitThumb('vid3p'), duration: '3:45', views: '234万', likes: '15.6万', tags: ['AI', '效率', '工具'] },
        { id: 'v4', title: '品牌故事 | 10年匠心，只为一杯好茶', desc: '品牌宣传片AI脚本创作，情感化叙事，提升品牌溢价能力', type: '宣传片', category: '宣传片', thumb: 'https://picsum.photos/seed/vid4/480/270', portraitThumb: makePortraitThumb('vid4p'), duration: '4:30', views: '56.7万', likes: '3.4万', tags: ['品牌', '茶叶', '情感'] },
        { id: 'v5', title: '双11限时优惠，错过再等一年！', desc: 'AI生成信息流广告视频，快速测试多版本，找到最优转化方案', type: '信息流', category: '信息流', thumb: 'https://picsum.photos/seed/vid5/480/270', portraitThumb: makePortraitThumb('vid5p'), duration: '0:45', views: '678万', likes: '2.1万', tags: ['电商', '促销', '广告'] },
        { id: 'v6', title: 'AI数字人讲解：量子计算入门', desc: '数字人AI视频，真实人脸同步，降低出镜成本，适合知识付费', type: '数字人', category: '数字人', thumb: 'https://picsum.photos/seed/vid6/480/270', portraitThumb: makePortraitThumb('vid6p'), duration: '8:20', views: '34.5万', likes: '2.8万', tags: ['科技', '数字人', '教育'] },
        { id: 'v7', title: '创业失败后我学到的5个教训', desc: 'AI混剪创业故事类视频，情感共鸣强，适合创业类账号涨粉', type: '混剪', category: '混剪', thumb: 'https://picsum.photos/seed/vid7/480/270', portraitThumb: makePortraitThumb('vid7p'), duration: '5:10', views: '456万', likes: '23.4万', tags: ['创业', '成长', '经验'] },
        { id: 'v8', title: '一本书读完《原则》核心要点', desc: '图文视频AI自动生成，知识卡片+配音，适合读书类账号', type: '图视', category: '图视', thumb: 'https://picsum.photos/seed/vid8/480/270', portraitThumb: makePortraitThumb('vid8p'), duration: '6:45', views: '123万', likes: '8.9万', tags: ['读书', '知识', '成长'] },
        { id: 'v9', title: '月薪3千如何理财？从0开始', desc: 'AI生成理财科普口播，数据可视化+口播结合，高互动率', type: '口播', category: '口播', thumb: 'https://picsum.photos/seed/vid9/480/270', portraitThumb: makePortraitThumb('vid9p'), duration: '4:20', views: '789万', likes: '34.5万', tags: ['理财', '财务', '知识'] },
        { id: 'v10', title: '国潮品牌发布会 2024新品', desc: '品牌发布会宣传片AI辅助创作，专业制作质感，大幅降低制作成本', type: '宣传片', category: '宣传片', thumb: 'https://picsum.photos/seed/vid10/480/270', portraitThumb: makePortraitThumb('vid10p'), duration: '3:00', views: '89万', likes: '4.5万', tags: ['品牌', '国潮', '发布会'] },
        { id: 'v11', title: '这款护肤品用了3个月真实反馈', desc: '电商信息流广告，AI生成真实感评测文案，高效测品利器', type: '信息流', category: '信息流', thumb: 'https://picsum.photos/seed/vid11/480/270', portraitThumb: makePortraitThumb('vid11p'), duration: '1:30', views: '345万', likes: '12万', tags: ['美妆', '测评', '电商'] },
        { id: 'v12', title: '古诗词里的哲学：道可道非常道', desc: '图文知识视频AI生成，传统文化类内容，小众赛道高互动', type: '图视', category: '图视', thumb: 'https://picsum.photos/seed/vid12/480/270', portraitThumb: makePortraitThumb('vid12p'), duration: '3:55', views: '67万', likes: '5.6万', tags: ['国学', '诗词', '文化'] },
        { id: 'v13', title: '30天学会吉他！零基础入门教学', desc: 'AI生成教学类视频脚本，分段式教学内容，适合知识付费账号', type: '图视', category: '图视', thumb: 'https://picsum.photos/seed/vid13/480/270', portraitThumb: makePortraitThumb('vid13p'), duration: '5:30', views: '45万', likes: '3.2万', tags: ['音乐', '教学', '技能'] },
        { id: 'v14', title: '数字人直播间24小时带货不停', desc: 'AI数字人直播解决方案，降低直播成本90%，全天候在线', type: '数字人', category: '数字人', thumb: 'https://picsum.photos/seed/vid14/480/270', portraitThumb: makePortraitThumb('vid14p'), duration: '0:30', views: '1234万', likes: '56万', tags: ['直播', '数字人', '电商'] },
      ]
    }
  },
  computed: {
    filteredVideos() {
      if (this.activeVideoCategory === '全部') return this.videos
      return this.videos.filter(v => v.category === this.activeVideoCategory)
    },
    doubledVideos() {
      // Double for seamless CSS marquee loop
      return [...this.filteredVideos, ...this.filteredVideos]
    },
    timeDisplay() {
      if (!this.currentVideo) return '0:00'
      const secs = Math.floor(this.progress * 300 / 100)
      return `${Math.floor(secs/60)}:${String(secs%60).padStart(2,'0')}`
    }
  },
  methods: {
    openPlayer(video) {
      this.currentVideo = video
      this.showModal = true
      this.progress = 0
      this.isPlaying = false
      document.body.style.overflow = 'hidden'
    },
    closePlayer() {
      this.showModal = false
      this.currentVideo = null
      this.stopPlay()
      document.body.style.overflow = ''
    },
    togglePlay() {
      this.isPlaying = !this.isPlaying
      if (this.isPlaying) {
        this.playInterval = setInterval(() => {
          this.progress += 0.5
          if (this.progress >= 100) { this.progress = 0; this.isPlaying = false; this.stopPlay() }
        }, 100)
      } else { this.stopPlay() }
    },
    stopPlay() {
      if (this.playInterval) { clearInterval(this.playInterval); this.playInterval = null }
      this.isPlaying = false
    },
    seek(e) {
      const rect = e.currentTarget.getBoundingClientRect()
      this.progress = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100))
    }
  },
  beforeDestroy() {
    this.stopPlay()
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.video-section {
  background: var(--bg-section);
  overflow: hidden;
}

.section-header { text-align: center; margin-bottom: 40px; }
.section-header .section-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: var(--primary-light);
  color: var(--primary);
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
}

/* Filters */
.video-filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 44px;
}
.filter-btn {
  padding: 8px 20px;
  border-radius: 100px;
  border: 1.5px solid var(--border);
  background: var(--bg-card);
  color: var(--text-muted);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.filter-btn:hover { border-color: var(--primary); color: var(--primary); }
.filter-btn.active {
  background: var(--gradient-brand);
  border-color: transparent;
  color: white;
  box-shadow: var(--shadow);
}

/* ── Full-width auto-scroll strip ── */
.video-strip-outer {
  width: 100%;
  overflow: hidden;
  /* Edge fade masks */
  mask-image: linear-gradient(90deg, transparent 0%, black 5%, black 95%, transparent 100%);
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, black 5%, black 95%, transparent 100%);
}

@keyframes scroll-left {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.video-strip {
  display: flex;
  gap: 16px;
  width: max-content;
  padding: 8px 0 16px;
  animation: scroll-left 40s linear infinite;
}
.video-strip.paused { animation-play-state: paused; }

/* ── Portrait card (9:16 ratio, 1.5× size) ── */
.video-card {
  position: relative;
  width: 285px;
  height: 507px; /* 285 × 16/9 ≈ 507 */
  border-radius: 22px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.video-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}

/* Thumbnail fills card */
.card-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}
.video-card:hover .card-img { transform: scale(1.06); }

/* Transparent gradient overlay — always visible */
.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.12) 0%,
    rgba(0, 0, 0, 0.0) 35%,
    rgba(0, 0, 0, 0.55) 68%,
    rgba(0, 0, 0, 0.88) 100%
  );
  z-index: 1;
}

/* Type badge — top left */
.card-type {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 3;
  padding: 3px 10px;
  background: var(--gradient-brand);
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  border-radius: 100px;
  letter-spacing: 0.04em;
}

/* Play icon — center, shows on hover */
.card-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.7);
  z-index: 3;
  width: 48px; height: 48px;
  border-radius: 50%;
  background: var(--gradient-brand);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(37, 99, 235, 0.6);
}
.video-card:hover .card-play {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

/* Bottom content — over overlay */
.card-bottom {
  position: absolute;
  bottom: 0;
  left: 0; right: 0;
  z-index: 2;
  padding: 16px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 1px 4px rgba(0,0,0,0.5);
}

.card-tags {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.card-tag {
  padding: 3px 10px;
  background: rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.92);
  border-radius: 100px;
  font-size: 0.7rem;
  font-weight: 600;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-views {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Modal ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  backdrop-filter: blur(8px);
}
.modal-player {
  background: var(--bg-card);
  border-radius: 24px;
  width: 100%;
  max-width: 840px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  position: relative;
}
.modal-close {
  position: absolute;
  top: 16px; right: 16px;
  width: 36px; height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}
.modal-close:hover { background: var(--primary); }

.modal-video { position: relative; }
.video-player-mock {
  position: relative;
  padding-top: 56.25%;
  background: #000;
  overflow: hidden;
}
.player-thumb {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
}
.player-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
}
.player-play-btn {
  width: 72px; height: 72px;
  border-radius: 50%;
  background: var(--gradient-brand);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(37, 99, 235, 0.5);
  transition: transform 0.2s;
}
.player-play-btn:hover { transform: scale(1.1); }

.player-controls {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  padding: 24px 20px 16px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
}
.progress-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  margin-bottom: 10px;
}
.progress-fill {
  height: 100%;
  background: var(--gradient-brand);
  border-radius: 2px;
  transition: width 0.1s;
}
.progress-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 12px; height: 12px;
  border-radius: 50%;
  background: white;
  transition: left 0.1s;
}
.player-info {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
}
.time-display { font-weight: 600; }

.modal-info { padding: 24px 28px; display: flex; flex-direction: column; gap: 12px; }
.modal-title { font-size: 1.15rem; font-weight: 800; color: var(--text); }
.modal-desc { font-size: 0.88rem; color: var(--text-muted); line-height: 1.7; }
.modal-tags { display: flex; gap: 8px; flex-wrap: wrap; }
.modal-tags .card-tag {
  background: var(--primary-light);
  color: var(--primary);
  border: none;
  backdrop-filter: none;
}
.modal-cta { display: flex; gap: 12px; flex-wrap: wrap; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition: all 0.3s ease; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }

@media (max-width: 768px) {
  .video-card { width: 200px; height: 355px; }
}
@media (max-width: 480px) {
  .video-card { width: 165px; height: 293px; }
}
</style>
